"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const styled_components_1 = require("styled-components");
const StyledVideo = styled_components_1.default.video `
  width: auto;
  max-width: 100%;
`;
const StyledEmbed = styled_components_1.default.div `
	position: relative;
	padding-bottom: 56.25%; /* 16:9 */
	height: 0;
  max-width: 100%;
  margin-bottom: 16px;
  width: ${props => props.width};
`;
const StyledFrame = styled_components_1.default.iframe `
  position: absolute;
	top: 0;
  right: 0;
  bottom: 0;
	left: 0;
	width: 100%;
	height: 100%;
  border: none;
  margin-bottom: 16px;
`;
exports.MarkdownVideo = props => {
    const controls = flag(props.controls, true);
    const autoPlay = def(props.autoPlay, false);
    const loop = def(props.loop, false);
    const playsInline = def(props.playsInline, false);
    const muted = def(props.muted, false);
    if (props.provider === "youtube") {
        const frags = props.src.split('/').filter(Boolean);
        const id = (frags[frags.length - 1] || '').split('?')[0];
        return (React.createElement(StyledEmbed, { width: props.width },
            React.createElement(StyledFrame, { src: `https://www.youtube-nocookie.com/embed/${id}/`, allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" })));
    }
    if (props.provider === "vimeo") {
        const frags = props.src.split('/').filter(Boolean);
        const id = (frags[frags.length - 1] || '').split('?')[0];
        return (React.createElement(StyledEmbed, { width: props.width },
            React.createElement(StyledFrame, { src: `https://player.vimeo.com/video/${id}/`, allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" })));
    }
    const { provider: _, src: __, controls: ___ } = props, p = __rest(props, ["provider", "src", "controls"]);
    return React.createElement(StyledVideo, { src: props.src, controls: controls, autoPlay: autoPlay, loop: loop, playsInline: playsInline, muted: muted });
};
function def(input, fb) {
    if (typeof input === 'undefined') {
        return fb;
    }
    return input;
}
function flag(input, fb) {
    return typeof input === "undefined"
        ? fb
        : input === "true";
}
//# sourceMappingURL=markdown-video.js.map